import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "children", "content", "referenceRef", "placement", "offset", "distance", "arrowSize", "positionFixed", "adaptivePositioning", "matchReferenceWidth"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { forwardRef } from 'react';
import PopoverCard from 'components/PopoverCard';
import usePopover from 'hooks/usePopover';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var Popover = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var as = _ref.as,
    children = _ref.children,
    content = _ref.content,
    referenceRef = _ref.referenceRef,
    placement = _ref.placement,
    offset = _ref.offset,
    distance = _ref.distance,
    arrowSize = _ref.arrowSize,
    positionFixed = _ref.positionFixed,
    adaptivePositioning = _ref.adaptivePositioning,
    matchReferenceWidth = _ref.matchReferenceWidth,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var popover = usePopover({
    ref: ref,
    referenceRef: referenceRef,
    placement: placement,
    offset: offset,
    distance: distance,
    arrowSize: arrowSize,
    positionFixed: positionFixed,
    adaptivePositioning: adaptivePositioning,
    matchReferenceWidth: matchReferenceWidth
  });
  return (
    /*#__PURE__*/
    /*
     Warning!!! `PopoverCard` is currently not being properly typechecked.
     Comment out `otherProps` and `as` when making changes to check types 
    */
    _jsxs(_Fragment, {
      children: [children({
        ref: popover.setReferenceRef,
        update: popover.update
      }), /*#__PURE__*/_jsx(PopoverCard, _objectSpread(_objectSpread(_objectSpread({}, otherProps), {}, {
        as: as || 'div'
      }, popover.props), {}, {
        ref: popover.setRef,
        arrow: popover.arrow,
        children: content
      }))]
    })
  );
});
Popover.displayName = 'Popover';
export default Popover;